import { dealInsightsFilterOptionKeys } from '@openx/types/dealInsights';
import { subDays } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { useSearchParams } from 'react-router';
import { dealInsightsStateFields } from '../constants';
import type { DealInsightsState } from '../types';
import { getDealInsightsSupportedDateRange } from '../utils/getDealInsightsSupportedDateRange';

export const useDealInsigthsInitialState = (): DealInsightsState => {
  const { maxDate } = getDealInsightsSupportedDateRange();
  const zonedTime = toZonedTime(new Date(), 'UTC');

  const [searchParams] = useSearchParams();
  const dealNameParam = searchParams.get('deal_name');
  const initialDealName = dealNameParam ? decodeURIComponent(dealNameParam) : '';
  const oxDealIdParam = searchParams.get('ox_deal_id');
  const initialOxDealId = oxDealIdParam ? parseInt(oxDealIdParam, 10) : 0;

  return {
    [dealInsightsStateFields.DATE_RANGE]: {
      startDate: subDays(zonedTime, 7),
      endDate: maxDate,
    },
    [dealInsightsStateFields.FILTERS]: {
      [dealInsightsFilterOptionKeys.DEAL]: initialOxDealId
        ? [{ name: initialDealName, deal_id: '', ox_deal_id: initialOxDealId, impressions: 0 }]
        : [],
      [dealInsightsFilterOptionKeys.DOMAIN_BUNDLE]: [],
      [dealInsightsFilterOptionKeys.BUYER_NAME]: [],
      [dealInsightsFilterOptionKeys.DSP_NAME]: [],
      [dealInsightsFilterOptionKeys.PUB_NAME]: [],
      [dealInsightsFilterOptionKeys.MEDIA_SUBTYPE]: [],
      [dealInsightsFilterOptionKeys.CHANNEL]: [],
      [dealInsightsFilterOptionKeys.TYPE_NAME]: [],
      [dealInsightsFilterOptionKeys.ADSIZE]: [],
      [dealInsightsFilterOptionKeys.AD_DURATION]: [],
    },
    [dealInsightsStateFields.LAST_OPENED_FILTER_KEY]: null,
  };
};
